// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_FLIGHT: `${environment.apiUrl}/flight/:id`,
  GET_ORDER: `${environment.apiUrl}/flight/:idFlight/order/:idOrder`,
  POST_RESERVE: `${environment.apiUrl}/flight/:idFlight/order/:idOrder`,
  POST_PHONE: `${environment.apiUrl}/auth/phone`,
});

export const getFlightApi = getCreator(fetch, endpoints.GET_FLIGHT);
export const getOrderApi = getCreator(fetch, endpoints.GET_ORDER);
export const postReserveApi = postCreator(fetch, endpoints.POST_RESERVE);
export const postPhoneApi = postCreator(fetch, endpoints.POST_PHONE);



// WEBPACK FOOTER //
// ./src/modules/reserve/api.js